import React, { useContext, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { UserContext } from "../../context/UserProvider";
import MuPb from "../../widgets/MuPb";
import {
  Alert,
  Container,
  Box,
  Typography,
  Card,
  CardContent,
  Fade,
  Zoom,
  CircularProgress,
  Button,
} from "@mui/material";
import useApiEp from "../../hooks/useApiEp";
import { getErrorResponse } from "../../utils/util";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";
import {
  LinearProgress,
  Paper,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
} from "@mui/material";
import { CheckCircleOutline, HourglassEmpty } from "@mui/icons-material";
const LoadingProcess = ({ isLoading }) => {
  if (isLoading) {
    return (
      <Fade in={true} timeout={500}>
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            minHeight: "50vh",
            mt: 10,
            px: 2,
          }}
        >
          <Paper
            elevation={3}
            sx={{
              p: 4,
              borderRadius: 3,
              maxWidth: 500,
              width: "100%",
              textAlign: "center",
              background: "linear-gradient(135deg, #f5f7fa 0%, #e3f2fd 100%)",
            }}
          >
            <Typography
              variant="h5"
              gutterBottom
              sx={{ fontWeight: "bold", color: "#1976d2" }}
            >
              Setting Up Your Account
            </Typography>
            <Typography variant="body1" color="text.secondary" sx={{ mb: 3 }}>
              We're getting everything ready for you. This won't take long!
            </Typography>

            <List>
              {[
                "Linking your account",
                "Creating your project",
                "Generating secure token",
                "Submitting WABA ID",
                "Subscribing to webhook",
              ].map((step, index) => (
                <ListItem key={index} sx={{ py: 1 }}>
                  <ListItemIcon>
                    <HourglassEmpty sx={{ color: "#1976d2" }} />
                  </ListItemIcon>
                  <ListItemText
                    primary={step}
                    primaryTypographyProps={{
                      variant: "body2",
                      fontWeight: "medium",
                    }}
                  />
                </ListItem>
              ))}
            </List>

            <LinearProgress
              sx={{
                mt: 2,
                height: 6,
                borderRadius: 3,
                backgroundColor: "#e3f2fd",
                "& .MuiLinearProgress-bar": {
                  backgroundColor: "#1976d2",
                },
              }}
            />
            <Typography
              variant="caption"
              color="text.secondary"
              sx={{ mt: 2, display: "block" }}
            >
              Please wait while we complete the setup...
            </Typography>
          </Paper>
        </Box>
      </Fade>
    );
  }
  return null; // Or render the main content when loading is complete
};
const AccountLink = () => {
  const { wabaId, phoneId } = useParams();
  const cusId = localStorage.getItem("cusId");
  const partner = localStorage.getItem("partner");
  const navigate = useNavigate();
  const { data, isLoading, isError, error } = useApiEp(
    `/partner/link-project-account/${wabaId}/${phoneId}/${cusId}/${partner}`,
    true,
    0
  );

  if (isLoading) {
    return <LoadingProcess isLoading={isLoading} />;
  }

  if (isError) {
    return (
      <Zoom in={true} style={{ transitionDelay: "100ms" }}>
        <Container maxWidth="sm" sx={{ mt: 4 }}>
          <Card variant="outlined">
            <CardContent>
              <Box sx={{ display: "flex", alignItems: "center", mb: 2 }}>
                <ErrorOutlineIcon color="error" sx={{ fontSize: 40, mr: 2 }} />
                <Typography variant="h5" color="error">
                  Linking Failed
                </Typography>
              </Box>
              <Alert severity="error" sx={{ mb: 2 }}>
                {getErrorResponse(error)}
              </Alert>
              <Button
                variant="contained"
                color="primary"
                onClick={() => window.location.reload()}
                sx={{ mt: 2 }}
              >
                Try Again
              </Button>
            </CardContent>
          </Card>
        </Container>
      </Zoom>
    );
  }

  return (
    <Fade in={true}>
      <Container maxWidth="md" sx={{ mt: 3 }}>
        <Card variant="outlined">
          <CardContent sx={{ textAlign: "center", py: 6 }}>
            <CheckCircleOutlineIcon
              color="success"
              sx={{ fontSize: 80, mb: 3 }}
            />
            <Typography
              variant="h4"
              gutterBottom
              sx={{ color: "success.main" }}
            >
              Account Linked Successfully!
            </Typography>
            <Typography variant="body1" sx={{ mb: 3 }}>
              The WhatsApp Business Account ({wabaId}) and phone number (
              {phoneId}) have been successfully linked to your project.
            </Typography>
            <Box sx={{ mt: 4 }}>
              <Button
                variant="contained"
                onClick={() => navigate("/home")}
                size="large"
              >
                Go to Dashboard
              </Button>
            </Box>
          </CardContent>
        </Card>
      </Container>
    </Fade>
  );
};

export default AccountLink;
